import { connect } from 'react-redux';
import { hasSubmitFailed, change as changeFormValue } from 'redux-form';
import { getErrors } from '../../../common/utils/validation';
import { getSelected, getTotalTravelersPrice, getProvince, getTravelersPriceError, getValidTravelers } from '../utils/selection';
import ManulifeInsurance from '../components/ManulifeInsurance';
import PersuasionModalProvider from '../../../common/context/PersuasionModalContext';
import { jsx as _jsx } from "react/jsx-runtime";
const PersuasionModalWrapper = props => /*#__PURE__*/_jsx(PersuasionModalProvider, {
  children: /*#__PURE__*/_jsx(ManulifeInsurance, {
    ...props
  })
});
const mapStateToProps = (state, _ref) => {
  let {
    form,
    productName
  } = _ref;
  return {
    errors: hasSubmitFailed(form)(state) ? getErrors(form, productName)(state) : null,
    hasPriceTravelerError: getTravelersPriceError(productName, form)(state),
    isProvinceSelected: Boolean(getProvince(productName, form)(state)),
    priceRaw: getTotalTravelersPrice(productName, form)(state),
    isSelected: getSelected(productName, form)(state),
    isTravelersValid: getValidTravelers(productName, form)(state)
  };
};
const updateTotalPrice = (dispatch, _ref2) => {
  let {
    form,
    productName
  } = _ref2;
  return priceRaw => {
    dispatch(changeFormValue(form, `${productName}.value.priceRaw`, priceRaw));
  };
};
const updateIsSelected = (dispatch, _ref3) => {
  let {
    form,
    productName
  } = _ref3;
  return isSelected => {
    dispatch(changeFormValue(form, `${productName}.value.value`, isSelected));
  };
};
const mapDispatchToProps = (dispatch, props) => ({
  updateTotalPrice: updateTotalPrice(dispatch, props),
  updateIsSelected: updateIsSelected(dispatch, props)
});
export default connect(mapStateToProps, mapDispatchToProps)(PersuasionModalWrapper);
//# sourceMappingURL=ManulifeInsuranceContainer.js.map